// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"e72c9895","280":"4c53fe2a","428":"1a1d1670","437":"fc0fc49b","442":"34707f95","447":"c22d6c2e","602":"ced9ecde","609":"f17de16a","659":"e13b0fcb","726":"569d687d","968":"3853685e"}[chunkId] + ".chunk.js";
};